// src/services/adminReviews.js
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../firebase";
 
// Admin view: fetch ALL reviews, newest first.
export async function fetchAllReviews() {
  const q = query(collection(db, "reviews"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}